import { extendTailwindMerge } from 'tailwind-merge';
import { clsx, type ClassValue } from 'clsx';
import { fontSize } from '../../design-tokens';

/**
 * tailwind-merge has to be told about the design system's type scale.
 *
 * Out of the box it knows Tailwind's own `text-sm`/`text-lg` as font sizes and treats every other
 * `text-*` as a colour — so `cn('text-foreground', 'text-body')` decides the two conflict and drops
 * the colour. The symptom is near-black body text on a dark background, everywhere except inside a
 * component that happens to set a colour last. Naming the six steps here is what stops that, and
 * the names come from the generated tokens so a change to the scale cannot leave this behind.
 */
const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: Object.keys(fontSize) }] } },
});

/** Merge class strings so a caller's className beats the component's own. RNR's own helper. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
